// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import Widget from '@arcgis/core/widgets/Widget';
import { tsx } from '@arcgis/core/widgets/support/widget';

import MapView from '@arcgis/core/views/MapView';
import SceneView from '@arcgis/core/views/SceneView';

import AreaMeasurement2D from '@arcgis/core/widgets/AreaMeasurement2D';
import AreaMeasurement3D from '@arcgis/core/widgets/AreaMeasurement3D';

import '@esri/calcite-components/dist/calcite/calcite.css';

interface AreaProps {
  view: MapView | SceneView;
  measurement: AreaMeasurement2D | AreaMeasurement3D;
}

class AreaWidget extends Widget {
  view: MapView | SceneView;

  measurement: AreaMeasurement2D | AreaMeasurement3D;

  isActive = false;

  name = 'AreaWidget3d';

  constructor(params: AreaProps) {
    super(params);
    this.view = params.view;
    this.measurement = params.measurement;
  }

  _handleClick() {
    if (!this.isActive) {
      this.measurement.visible = true;
      this.measurement.viewModel.start();
      this.isActive = true;
    } else {
      this.measurement.viewModel.clear();
      this.measurement.visible = false;
      this.isActive = false;
    }
    this.emit('measurement-toggle', { active: this.isActive });
  }

  render() {
    return tsx(
      'div',
      {
        class: 'esri-widget esri-widget--button',
        style: 'cursor:pointer',
        onclick: this._handleClick.bind(this),
      },
      tsx('calcite-icon', {
        icon: this.isActive ? 'x' : 'measure-area',
        scale: 'm',
        title: this.isActive ? 'Clear Area Measurement' : 'Measure Area',
      }),
    );
  }
}

export default AreaWidget;
